<template>
    <div>
      <br />
      <h2 class="ViewHeading">Virtual Logbook</h2>
      <div>
        <b-row><b-col>
            <h4>{{ this.selectedlocation }}</h4>
          </b-col></b-row>
        <b-row> </b-row>
      </div>
      <div>
        <b-card>
          <b-tabs @input="onTabChange" v-model="tabNo">
            <b-tab title="By Date">
              <b-card v-if="this.LogList.length == 0">
                <h4>You don't have any notes in log book at this time</h4>
              </b-card>
              <b-card v-if="this.LogList.length > 0">
                <b-alert
              v-for="(id, idx) in this.LogList.slice((currentPage -1)*perPage,currentPage*perPage)"
              :key="idx"
              show
              variant= "light"
            >
            <b-row><b-col cols="2" v-if="id['DeviceTag'] == 'NA'">{{ id["DeviceID"] }}</b-col><b-col cols="2" v-if="id['DeviceTag'] != 'NA'">{{ getNewName(id["DeviceID"],id["DeviceTag"]) }}</b-col><b-col cols="4">{{ id["Title"] }}</b-col>
              <b-col>{{ id["NoteDate"] }}</b-col><b-col>{{ id["NoteTime"] }}</b-col>
              <b-col align="right"><b-button variant="outline-secondary" v-on:click="expandLog(id,'Single')">Detail</b-button></b-col></b-row>
          </b-alert>
          <b-pagination
                    v-model="currentPage"
                    :total-rows="this.LogList.length"
                    :per-page="perPage"
                    size="sm"
                    align="center"
                  />
              </b-card>

            </b-tab>
            <b-tab title="By Device">
              <b-card v-if="this.DeviceLogList.length == 0">
                <h4>You don't have any notes in log book at this time</h4>
              </b-card>
              <b-card v-if="this.DeviceLogList.length > 0">
                <b-alert
              v-for="(id, idx) in this.DeviceLogList.slice((currentPageDevices -1)*perPageDevices,currentPageDevices*perPageDevices)"
              :key="idx"
              show
              variant= "light"
            >  
            <b-row><b-col v-if="id[0][9] == 'NA'">{{id[0][1]}}</b-col><b-col v-if="id[0][9] != 'NA'">{{getNewName(id[0][1],id[0][9])}}</b-col><b-col cols="2">{{ id.length }} Entries</b-col><b-col cols="4">Latest at {{ id[0][3] }}-{{ id[0][4] }} </b-col><b-col align="right"><b-button variant="outline-secondary" v-on:click="expandLog(id,'Device')">Detail</b-button></b-col></b-row>
            <!-- id[0][1]  -->
          </b-alert>
          <b-pagination
                    v-model="currentPageDevices"
                    :total-rows="this.DeviceLogList.length"
                    :per-page="perPageDevices"
                    size="sm"
                    align="center"
                  />
              </b-card>
            </b-tab>
            <b-tab title="Manual Entry">
              <ManualEntry />

            </b-tab>

          </b-tabs>
        </b-card>
        <br />
      </div>
      <b-modal
      ref="DeviceDetailModal"
      id="DeviceDetailModal"
      content-class="Modal"
      title="Log Entry"
      hide-footer
      centered
    >
    <b-alert v-for="(id, idx) in modifiednotedetail"
    :key="idx"
    show
    variant= "light">
      <b-row><b-col><b>Detail:</b></b-col></b-row>
      <b-row><b-col>{{ id[8] }}</b-col><b-col>{{ id[3] }}</b-col><b-col>{{ id[4] }}</b-col></b-row>
      <br/>
      <b-row><b-col><b>Note Trigger:</b></b-col></b-row>
      <b-row><b-col>{{ id[5] }}</b-col></b-row>
      <hr/>
      <b-row><b-col><b>Content:</b></b-col></b-row>
      <b-row><b-col>{{ id[6] }}</b-col></b-row>
      <br/>
      <b-row><b-col>{{ id[7] }}</b-col></b-row>
    </b-alert>
  </b-modal>
  <b-modal
      ref="SingleDetailModal"
      id="SingleDetailModal"
      content-class="Modal"
      title="Log Entry"
      hide-footer
      centered
    >
    <b-row><b-col><b>Detail:</b></b-col></b-row>
   <b-row><b-col>{{ notedetail.User }}</b-col><b-col>{{ notedetail.NoteDate }}</b-col><b-col>{{ notedetail.NoteTime }}</b-col></b-row>
   <br/>
   <b-row><b-col><b>Note Trigger:</b></b-col></b-row>
   <b-row><b-col>{{ notedetail.NoteTrigger }}</b-col></b-row>
   <hr/>
   <b-row><b-col><b>Content:</b></b-col></b-row>
   <b-row><b-col>{{ notedetail.Title }}</b-col></b-row>
   <br/>
   <b-row><b-col>{{ notedetail.Text }}</b-col></b-row>
  </b-modal>
      <b-modal
      ref="LoadingModal"
      id="LoadingModal"
      content-class="Modal"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
      hide-header
    >
     <div class="container_row" >
        <div class="layer2">
          <h1 class="HeadingText1">Loading Data...</h1>

          <img
            class="Logo"
            alt="Angelguard logo"
            src="../assets/LogoOnly.png"
          />
        </div>
    </div>
</b-modal>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { IDToHuman } from "@/CustomFunctions/HumanName.js";
  import { UTCToTimeZone } from "@/CustomFunctions/Timezone.js";
  import ManualEntry from "@/components/ManualVLog.vue"
  
  
  export default {
    data() {
      return {
        perPage: 5,
        perPageDevices: 4,
        currentPage:1,
        currentPageDevices: 1,
        selectedlocation: localStorage.getItem("location"),
        UserAccess: localStorage.getItem("accessGroup"),
        UserURN: localStorage.getItem("UserURN"),
        UserProfile: localStorage.getItem("profileportal"),
        fullname: localStorage.getItem("fullname"),
        o1array:[],
        c1array:[],
        loaded: false,
        notedetail: [],
        modifiednotedetail: [],
        LogList: [],
        DeviceLogList: [],
        DeviceName: "",
        DeviceIDToChange: { C1: [], O1: [] },
        IDsIhaveChanged: { C1: [], O1: [] },
        IDsToChange: { C1: [], O1: [] },
        tabNo: this.$tab,
      };
    },
    computed:{
    },
    beforeMount(){

  },
    mounted() {
      this.loaded = false;

      let LookUpLogsUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpLogsHeaders = this.$apikeyPost;
    let LookUpLogsRequest = {
      RequestType: "Logbook",
      Location: this.selectedlocation,
    };
    axios
      .post(LookUpLogsUrl, LookUpLogsRequest, LookUpLogsHeaders)
      .then((response) => {
        let Responsearray = []
        Responsearray = response.data.Values

        this.LogList = []
        for (let i = 0; i < Responsearray.length; i++) {
          let DeviceTag = ""
          if(Responsearray[i][1].startsWith("eui")){
              this.o1array.push(Responsearray[i][1])
              DeviceTag = "O1"
            } else if(Responsearray[i][1] == "N/A"){
              DeviceTag = "NA"
            }        
            else {
              this.c1array.push(Responsearray[i][1])
              DeviceTag = "C1"
            }
            this.LogList.push({
              DeviceID: Responsearray[i][1] ,
              NoteDate: Responsearray[i][3],
              NoteTime: Responsearray[i][4], 
              NoteTrigger: Responsearray[i][5],
              Title: Responsearray[i][6],
              Text: Responsearray[i][7],
              User: Responsearray[i][8],
              Detail: "",
              DeviceTag: DeviceTag
            });

          }

        this.DeviceLogList = []
        let grouplist = Object.groupBy(Responsearray, r => r[1]);
        for (const entry of Object.values(grouplist)) {
          let DeviceTag = ""
          if(entry[0][1].startsWith("eui")){
            DeviceTag = "O1"
          } else if(entry[0][1] == "N/A"){
              DeviceTag = "NA"
            }        else {
            DeviceTag = "C1"
          }
          entry[0].push(DeviceTag)
          this.DeviceLogList.push(entry)}

      for (let x = 0; x < this.c1array.length; x++) {
            this.IDGetArrays(this.c1array[x], "C1");
          }
      for (let y = 0; y < this.o1array.length; y++) {
            this.IDGetArrays(this.o1array[y], "O1");
          }

      this.SwitchToHuman("C1");
      this.SwitchToHuman("O1");

      this.loaded = true

      });
      
    },
  
    components: {
      ManualEntry
    },
    methods: {
      Showloader() {
      if (this.loaded) {
        this.$bvModal.hide("LoadingModal");
      } else if (this.loaded == false) {
        this.$bvModal.show("LoadingModal");
      }
    },
    expandLog(item,table){   
      if(table == 'Device'){
        this.modifiednotedetail = []
        this.modifiednotedetail = item
        this.$refs["DeviceDetailModal"].show(this.modifiednotedetail);
      } else if(table == 'Single'){
        this.notedetail = []
        this.notedetail = item
        this.$refs["SingleDetailModal"].show(this.notedetail);
      }
    },
    UpdateTimeDate(Date, Time) {
      let timeDate = UTCToTimeZone(Date, Time);
      return timeDate;
    },
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      Type = Type.replace("-", "");
      if (Type == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
            
          }
        }
      } else if (Type == "C1") {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data.ID;
    },
    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },
    onTabChange(){
      if (this.tabNo == 2){
        return;
      } else{
        this.RefreshLists()
      }
    },
    RefreshLists(){
      this.loaded = false;

      let LookUpLogsUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
        "/lookup";
      let LookUpLogsHeaders = this.$apikeyPost;
      let LookUpLogsRequest = {
      RequestType: "Logbook",
      Location: this.selectedlocation,
      };
      axios
      .post(LookUpLogsUrl, LookUpLogsRequest, LookUpLogsHeaders)
      .then((response) => {
        let Responsearray = response.data.Values
        this.LogList = []
        for (let i = 0; i < Responsearray.length; i++) {
          let DeviceTag = ""
        if(Responsearray[i][1].startsWith("eui")){
           this.o1array.push(Responsearray[i][1])
            DeviceTag = "O1"
        } else if(Responsearray[i][1] == "N/A"){
              DeviceTag = "NA"
            }  else{
            this.c1array.push(Responsearray[i][1])
            DeviceTag = "C1"
        }
        this.LogList.push({
          DeviceID: Responsearray[i][1] ,
          NoteDate: Responsearray[i][3],
          NoteTime: Responsearray[i][4], 
          NoteTrigger: Responsearray[i][5],
          Title: Responsearray[i][6],
          Text: Responsearray[i][7],
          User: Responsearray[i][8],
          Detail: "",
          DeviceTag: DeviceTag
        });
    }
    this.DeviceLogList = []
    let grouplist = Object.groupBy(Responsearray, r => r[1]);
    for (const entry of Object.values(grouplist)) {
      let DeviceTag = ""
      if(entry[0][1].startsWith("eui")){
        DeviceTag = "O1"
      } else if(entry[0][1] == "N/A"){
              DeviceTag = "NA"
            }   else {
        DeviceTag = "C1"
      }
      entry[0].push(DeviceTag)
      this.DeviceLogList.push(entry)}


    for (let x = 0; x < this.c1array.length; x++) {
        this.IDGetArrays(this.c1array[x], "C1");
      }
    for (let y = 0; y < this.o1array.length; y++) {
        this.IDGetArrays(this.o1array[y], "O1");
      }

  this.SwitchToHuman("C1");
  this.SwitchToHuman("O1");

  this.loaded = true

});
    }
    },
    watch: {
      loaded() {
      this.Showloader();
    },

    },
 
  };
  </script>
  <style scoped>
.content {
    text-align: center;
  }
  
.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
  background-color: rgb(109, 136, 195);
  opacity: 0.5;
}
.layer1 span {
  display: grid;
  place-items: center;
}

.Logo {
  scale: 150%;
  margin-top: 5rem;
  width: 15%;
  min-width: 150px;
}

.alert-light {
    color: #525252;
    background-color: #fefefe;
    border-color: #818182;
}
</style>
  